import React, { useState, useEffect } from 'react'
import { Tabs, Tab, Typography, Box } from '@mui/material'
import { withStyles } from '@mui/styles'
import { useNavigate, useLocation } from 'react-router-dom'
import { parse } from 'qs'

import { CompanyForm } from '../form/company-form.component'
import { useCombos } from '../../../combos'
import { eeiiTabsStyles } from './eeii-tabs.styles'
import { PrescriptorsPanel } from '../prescriptors-panel/prescriptors-panel'

const getComboLabel = (combos, comboId, key, fallback = '--') => {
  if (!key || !combos) return fallback
  const comboData = combos[comboId]?.data || combos[comboId] || []
  if (!Array.isArray(comboData)) return fallback
  const item = comboData.find((el) => String(el.key) === String(key))
  return item ? item.value : fallback
}
const TabTitle = ({ company, combos }) => {
  const ccaaName = getComboLabel(combos, 'cod_zona_zeus', company.comunidad_autonoma)

  return (
    <>
      <Typography variant="subtitle1" color="primary">
        {company.nombre}
      </Typography>
      {company.comunidad_autonoma && (
        <Typography variant="caption">{ccaaName}</Typography>
      )}
    </>
  )
}
export const EEIITabs = withStyles(eeiiTabsStyles)(({
  classes,
  primaryCompany,
  secondaryCompanies = [],
  getEIData,
}) => {
  const combos = useCombos(['cod_zona_zeus'])
  const navigate = useNavigate()
  const location = useLocation()
  const params = parse(location.search.substring(1))

  let defaultTabIndex = 0
  if (params.ca) {
    const selectedSecCompanyIndex = secondaryCompanies.findIndex(
      (company) => company.id.toString() === params.ca
    )
    if (selectedSecCompanyIndex !== -1) {
      defaultTabIndex = selectedSecCompanyIndex + 1
    }
  }

  const [selectedTabIndex, setSelectedTabIndex] = useState(defaultTabIndex)

  const handleChange = (_, newValue) => {
    setSelectedTabIndex(newValue)
    const secondaryCompanyId = secondaryCompanies[newValue - 1]?.id
    const newParams = secondaryCompanyId ? `?ca=${secondaryCompanyId}` : ''
    navigate(`${location.pathname}${newParams}`)
  }

  useEffect(() => {
    if (!secondaryCompanies[selectedTabIndex - 1]) {
      setSelectedTabIndex(0)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  const isPrimary = selectedTabIndex === 0 || !secondaryCompanies[selectedTabIndex - 1]
  const currentCompany = isPrimary
    ? primaryCompany
    : {
      ...secondaryCompanies[selectedTabIndex - 1],
      publica: primaryCompany.publica,
    }
  const rawInstaladores =
    currentCompany?.instaladores_colaboradores ||
    primaryCompany?.instaladores_colaboradores ||
    []

  const instaladoresList = rawInstaladores.filter(
    (inst) => inst.comunidad_autonoma === currentCompany.comunidad_autonoma
  )

  const isPrescriptor =
    primaryCompany?.prescriptor ||
    currentCompany?.prescriptor ||
    Boolean(instaladoresList.length)
  return (
    <>
      <Tabs value={selectedTabIndex} onChange={handleChange} variant="scrollable">
        <Tab
          key={0}
          label={<TabTitle company={primaryCompany} combos={combos} />}
          classes={{ selected: classes.tabSelected }}
        />

        {secondaryCompanies.map((company, i) => (
          <Tab
            key={i + 1}
            label={<TabTitle company={company} combos={combos} />}
            classes={{ selected: classes.tabSelected }}
          />
        ))}
      </Tabs>
      <Box p={3} bgcolor="grey.100">
        <CompanyForm
          model={currentCompany}
          isPrimaryCompany={isPrimary}
          getEIData={isPrimary ? getEIData : undefined}
        />
        {isPrescriptor && (
          <PrescriptorsPanel instaladores={instaladoresList} />
        )}
      </Box>
    </>
  )
})
